var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot-line-wrapper"},[_c('el-row',[_c('el-col',{staticClass:"count-edit",attrs:{"align":"center","span":24}},[_c('div',{staticClass:"scheduled-range",on:{"click":_vm.toggleCount}},[_vm._v(_vm._s(_vm.getMax()))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }